import React from 'react';
import Icon from './Icon';
import { FAMILIES } from '../../config/assessmentFamilies';

/** Prototype famIcon(). `size`: '' (34px) | 'm' (30px) | 's' (24px) | 'l' (48px). */
export function FamilyIcon({ fam, size = '', iconSm = true }) {
  const f = FAMILIES[fam] || FAMILIES.ai;
  return (
    <span className={`wz-fam${size ? ` ${size}` : ''} ${FAMILIES[fam] ? fam : 'ai'}`} aria-hidden="true">
      <Icon name={f.icon} sm={iconSm} />
    </span>
  );
}

/** Prototype .famtag: the family label as a tinted pill. */
export function FamilyTag({ fam }) {
  const f = FAMILIES[fam] || FAMILIES.ai;
  return <span className={`wz-famtag ${FAMILIES[fam] ? fam : 'ai'}`}>{f.label}</span>;
}
